import { Accordion } from "@merge-api/merge-javascript-shared";
import ComparisonRow from "./ComparisonRow";
import { DiffExecutionResults } from "../../entities";
import DifferentFieldAccordion from "./DifferentFieldAccordion";

interface TotalModelCountRowProps {
  diffRunResults: DiffExecutionResults;
}

const TotalModelCountRow = ({ diffRunResults }: TotalModelCountRowProps) => {
  return (
    <Accordion
      chevronOrientation="down"
      title={
        <ComparisonRow
          label="Total model count"
          stagedValue={diffRunResults.total_staged_blueprint_version_model_count}
          publishedValue={diffRunResults.total_published_blueprint_version_model_count}
          isAccordion={true}
        />
      }
      variant="none"
      titleClassName="px-5"
    >
      <div className="pb-1">
        {diffRunResults.models?.map((model, index) => (
          <div key={model.model_name}>
            <ComparisonRow
              label={model.model_name}
              stagedValue={model.staged_blueprint_version_model_count}
              publishedValue={model.published_blueprint_version_model_count}
              isSubModel={true}
            />
            <DifferentFieldAccordion different_fields={model.different_fields} />
            {index < (diffRunResults.models?.length || 0) - 1 && (
              <hr className="ml-8 mr-5 h-[0.5px] m-0 text-gray-40" />
            )}
          </div>
        ))}
      </div>
    </Accordion>
  );
};

export default TotalModelCountRow;
